export function hasTauriRuntime() {
  if (typeof window === 'undefined') {
    return false
  }

  const tauriWindow = window as Window & {
    __TAURI_INTERNALS__?: unknown
    __TAURI__?: unknown
  }

  if (
    typeof tauriWindow.__TAURI_INTERNALS__ !== 'undefined' ||
    typeof tauriWindow.__TAURI__ !== 'undefined'
  ) {
    return true
  }

  const protocol = tauriWindow.location?.protocol?.toLowerCase()
  if (protocol === 'tauri:') {
    return true
  }

  const href = tauriWindow.location?.href?.toLowerCase() || ''
  if (href.startsWith('tauri://')) {
    return true
  }

  const userAgent = tauriWindow.navigator?.userAgent?.toLowerCase() || ''
  return userAgent.includes('tauri')
}
